import type { FC } from 'react';

import classNames from 'classnames';

import {
  type AriaProps,
  ariaToReactProps,
} from '@iconik-io/shared-lib/src/react/a11y/aria';
import { Icon } from '@iconik-io/uad';

import styles from './badge.module.css';

export type BadgeType = number | 'empty' | 'checkmark';

type Props = {
  badge?: BadgeType;
  color?: string;
  className?: string;
  aria?: AriaProps;
};

const Badge: FC<Props> = ({ color, badge, className, aria }) => {
  if (badge) {
    const getBadgeContent = () => {
      if (typeof badge === 'number') {
        return badge;
      }
      if (badge === 'empty') {
        return null;
      }
      if (badge === 'checkmark') {
        return (
          <span className={styles.checkmark_container}>
            <Icon name="checkmark" size="xs" />
          </span>
        );
      }
    };
    return (
      <div
        className={classNames(styles.root, className)}
        style={{
          backgroundColor: color,
        }}
        role="alert"
        aria-live="polite"
        {...ariaToReactProps(aria)}
      >
        {getBadgeContent()}
      </div>
    );
  }
  return null;
};

export default Badge;
